module.exports = __webpack_public_path__ + "static/media/ct-bulb-square.e8d94392.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/icons/ct-bulb-square.jpg
 ** module id = 683
 ** module chunks = 0
 **/